/*
  Global appointment-request modals for the STEPEVI store locations.
  Loaded from snippets/appointment-modals.liquid, which defines the
  translated strings as window.APPT_I18N before this file runs.
*/

var APPT_LOCATIONS = [
  {
    name: 'STEPEVI Istanbul',
    address: 'Nispetiye St. Meydan Sk. Edin&Suner Plaza No: 14 Etiler, 34335',
    phone: '+90 212 352 2169',
    email: 'etiler@stepevi.com'
  },
  {
    name: 'STEPEVI London',
    address: "274 King's Rd, Chelsea, London SW3 5AW",
    phone: '+44 20 7376 7574',
    email: 'stepevilondon@stepevi.com'
  },
  {
    name: 'STEPEVI Paris',
    address: '12, boulevard Raspail Paris, 75007',
    phone: '+33 1 45 48 48 58',
    email: 'stepeviparis@stepevi.com'
  },
  {
    name: 'STEPEVI Milan',
    address: "Via dell'Orso, 9 Milan, 20121 - Italy",
    phone: '+39 02 874119',
    email: 'stepevimilan@stepevi.com'
  },
  {
    name: 'STEPEVI Munich',
    address: 'Maximiliansplatz 15, 80333 Munich, Germany',
    phone: '+49 89 45221800',
    email: 'stepevimunich@stepevi.com'
  },
  {
    name: 'STEPEVI Ankara',
    address: 'Turan Gunes Boulevard No: 78/A Yildiz, Ankara',
    phone: '+90 312 440 65 84',
    email: 'ankarayildiz@stepevi.com'
  }
];

function apptToHandle(str) {
  return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}

function apptBuildModals() {
  var container = document.getElementById('appt-modals-container');
  if (!container) return;
  APPT_LOCATIONS.forEach(function (store) {
    var handle = apptToHandle(store.name);
    var modal = document.createElement('div');
    modal.className = 'appt-modal';
    modal.id = 'appt-modal-' + handle;
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    var cityLabel = store.name.replace('STEPEVI ', '');
    modal.innerHTML = `
      <div class="appt-modal__backdrop" data-appt-close></div>
      <div class="appt-modal__panel">
        <button class="appt-modal__close" data-appt-close aria-label="${APPT_I18N.close}">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>
          </svg>
        </button>
        <div class="appt-modal__header">
          <p class="appt-modal__eyebrow">STEPEVI ${cityLabel}</p>
          <h2 class="appt-modal__title">${APPT_I18N.scheduleVisit}</h2>
          <p class="appt-modal__subtitle">${APPT_I18N.confirmNotice}</p>
        </div>
        <div class="appt-modal__body">
          <div class="appt-form" id="appt-form-${handle}">
            <div class="appt-form__row appt-form__row--half">
              <div class="appt-form__field">
                <label class="appt-form__label" for="appt-name-${handle}">${APPT_I18N.fullName}</label>
                <input class="appt-form__input" type="text" id="appt-name-${handle}" name="name" placeholder="${APPT_I18N.namePlaceholder}" autocomplete="name" required>
              </div>
              <div class="appt-form__field">
                <label class="appt-form__label" for="appt-email-${handle}">${APPT_I18N.email}</label>
                <input class="appt-form__input" type="email" id="appt-email-${handle}" name="email" placeholder="${APPT_I18N.emailPlaceholder}" autocomplete="email" required>
              </div>
            </div>
            <div class="appt-form__row appt-form__row--half">
              <div class="appt-form__field">
                <label class="appt-form__label" for="appt-phone-${handle}">${APPT_I18N.phone}</label>
                <input class="appt-form__input" type="tel" id="appt-phone-${handle}" name="phone" placeholder="${APPT_I18N.phonePlaceholder}" autocomplete="tel">
              </div>
              <div class="appt-form__field">
                <label class="appt-form__label" for="appt-date-${handle}">${APPT_I18N.preferredDate}</label>
                <input class="appt-form__input appt-form__input--date" type="date" id="appt-date-${handle}" name="date" required>
              </div>
            </div>
            <div class="appt-form__row appt-form__row--half">
              <div class="appt-form__field">
                <label class="appt-form__label" for="appt-time-${handle}">${APPT_I18N.preferredTime}</label>
                <div class="appt-form__select-wrap">
                  <select class="appt-form__input appt-form__select" id="appt-time-${handle}" name="time" required>
                    <option value="" disabled selected>${APPT_I18N.selectTime}</option>
                    <option value="10:00">10:00</option>
                    <option value="11:00">11:00</option>
                    <option value="12:00">12:00</option>
                    <option value="13:00">13:00</option>
                    <option value="14:00">14:00</option>
                    <option value="15:00">15:00</option>
                    <option value="16:00">16:00</option>
                    <option value="17:00">17:00</option>
                    <option value="18:00">18:00</option>
                  </select>
                  <span class="appt-form__select-arrow">
                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                  </span>
                </div>
              </div>
              <div class="appt-form__field"></div>
            </div>
            <div class="appt-form__row">
              <div class="appt-form__field">
                <label class="appt-form__label" for="appt-notes-${handle}">${APPT_I18N.notes} <span class="appt-form__optional">${APPT_I18N.optional}</span></label>
                <textarea class="appt-form__input appt-form__textarea" id="appt-notes-${handle}" name="notes" placeholder="${APPT_I18N.notesPlaceholder}" rows="3"></textarea>
              </div>
            </div>
            <div class="appt-form__row appt-form__row--footer">
              <p class="appt-form__error" id="appt-error-${handle}" aria-live="polite"></p>
              <button class="appt-form__submit" type="button" data-store-name="${store.name}" data-store-email="${store.email}" data-modal-handle="${handle}">
                <span class="appt-form__submit-label">${APPT_I18N.requestAppointment}</span>
                <span class="appt-form__submit-spinner" aria-hidden="true"></span>
              </button>
            </div>
          </div>
          <div class="appt-success" id="appt-success-${handle}" aria-live="polite" hidden>
            <div class="appt-success__icon">
              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="14" cy="14" r="13" stroke="currentColor" stroke-width="1.2"/>
                <path d="M8 14L12 18L20 10" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3 class="appt-success__title">${APPT_I18N.requestReceived}</h3>
            <p class="appt-success__message">${APPT_I18N.successMessageTemplate.replace('__STORE__', store.name)}</p>
            <button class="appt-success__close" data-appt-close>${APPT_I18N.close}</button>
          </div>
        </div>
      </div>
    `;
    container.appendChild(modal);
  });
}

function apptInitModalBehavior() {
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-appt-close]')) {
      var modal = e.target.closest('.appt-modal');
      if (modal) apptCloseModal(modal);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.appt-modal.is-open');
      if (open) apptCloseModal(open);
    }
  });

  document.addEventListener('click', function (e) {
    var submitBtn = e.target.closest('.appt-form__submit');
    if (submitBtn) apptHandleSubmit(submitBtn);
  });
}

function apptOpenModal(handle) {
  var modal = document.getElementById('appt-modal-' + handle);
  if (!modal) return;
  modal.classList.add('is-open');
  modal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  var dateInput = modal.querySelector('input[type="date"]');
  if (dateInput) {
    var today = new Date().toISOString().split('T')[0];
    dateInput.min = today;
  }
}

function apptCloseModal(modal) {
  modal.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

// Exposed so any widget on the page (e.g. the Store Locator by Byte app block's
// "Directions" links) can trigger the appointment modal for a given store name.
window.stepeviOpenApptModal = function (storeName) {
  if (!storeName) return;
  var handle = apptToHandle(storeName);
  if (document.getElementById('appt-modal-' + handle)) {
    apptOpenModal(handle);
  } else {
    console.warn('STEPEVI: no appointment modal found for store', storeName);
  }
};

function apptHandleSubmit(btn) {
  var handle = btn.getAttribute('data-modal-handle');
  var modal = document.getElementById('appt-modal-' + handle);
  if (!modal) return;

  var name      = modal.querySelector('#appt-name-' + handle).value.trim();
  var email     = modal.querySelector('#appt-email-' + handle).value.trim();
  var phone     = modal.querySelector('#appt-phone-' + handle).value.trim();
  var date      = modal.querySelector('#appt-date-' + handle).value;
  var time      = modal.querySelector('#appt-time-' + handle).value;
  var notes     = modal.querySelector('#appt-notes-' + handle).value.trim();
  var errorEl   = modal.querySelector('#appt-error-' + handle);
  var storeName  = btn.getAttribute('data-store-name');
  var storeEmail = btn.getAttribute('data-store-email');

  errorEl.textContent = '';
  if (!name || !email || !date || !time) {
    errorEl.textContent = 'Please fill in all required fields.';
    return;
  }
  var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRe.test(email)) {
    errorEl.textContent = 'Please enter a valid email address.';
    return;
  }

  btn.classList.add('is-loading');
  btn.disabled = true;

  var templateParams = {
    store_name:     storeName,
    store_email:    storeEmail,
    bcc_email:       'uilgaz@stepevi.com',
    customer_name:  name,
    customer_email: email,
    customer_phone: phone || '—',
    preferred_date: date,
    preferred_time: time,
    notes:          notes || '—',
  };

  var SERVICE_ID        = 'service_snxk2k5';
  var TEMPLATE_SHOWROOM = 'template_bfd63ii';
  var TEMPLATE_CUSTOMER = 'template_d8gugwu';

  Promise.all([
    emailjs.send(SERVICE_ID, TEMPLATE_SHOWROOM, templateParams),
    emailjs.send(SERVICE_ID, TEMPLATE_CUSTOMER, templateParams)
  ])
    .then(function () {
      btn.classList.remove('is-loading');
      btn.disabled = false;
      modal.querySelector('#appt-form-' + handle).hidden = true;
      modal.querySelector('#appt-success-' + handle).hidden = false;
    })
    .catch(function (err) {
      btn.classList.remove('is-loading');
      btn.disabled = false;
      errorEl.textContent = 'Something went wrong. Please try again or contact us directly.';
      console.error('EmailJS error:', err);
    });
}

function apptInit() {
  apptBuildModals();
  apptInitModalBehavior();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', apptInit);
} else {
  apptInit();
}

/* ── EmailJS loader ──────────────────────────────────── */
(function () {
  var s = document.createElement('script');
  s.src = 'https://cdn.jsdelivr.net/npm/@emailjs/browser@4/dist/email.min.js';
  s.onload = function () {
    emailjs.init({ publicKey: 'kXqLx8AdvyNq2XD5T' });
  };
  document.head.appendChild(s);
})();

/* ── Store Locator by Byte rewiring ──────────────────── */
/*
  The Store Locator by Byte app block renders its own "Directions" links —
  in the sidebar list and in the map marker's info-window popup — and the
  info-window content is only created after a marker is clicked, so we can't
  just query for it once on load. A MutationObserver catches both cases.
*/
(function () {
  var DIRECTIONS_SELECTOR = '.byte-single-list-item-direction, .mapinfo-actions a[href*="maps/dir"]';

  function apptLabel() {
    return (typeof APPT_I18N !== 'undefined' && APPT_I18N.scheduleVisit) || 'Schedule an Appointment';
  }

  function relabel(link) {
    var walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.textContent.trim()) {
        node.textContent = node.textContent.replace(/Directions/i, apptLabel());
      }
    }
  }

  function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    var link = e.currentTarget;
    var container = link.closest('.byte-single-list-item') || link.closest('.mapinfo-popup');
    var nameEl = container ? container.querySelector('strong') : null;
    var storeName = nameEl ? nameEl.textContent.trim() : '';
    if (typeof window.stepeviOpenApptModal === 'function') {
      window.stepeviOpenApptModal(storeName);
    }
  }

  function rewire(root) {
    root.querySelectorAll(DIRECTIONS_SELECTOR).forEach(function (link) {
      if (link.dataset.apptRewired) return;
      link.dataset.apptRewired = 'true';
      relabel(link);
      link.setAttribute('href', '#');
      link.removeAttribute('target');
      link.removeAttribute('rel');
      link.addEventListener('click', handleClick);
    });
  }

  /*
    The app block only shows each item's footer (Schedule a Visit / phone)
    when the item has the "expanded" class, toggled by its own accordion JS.
    We want the buttons always visible, so force-expand every item and
    re-apply whenever the app's JS collapses one.
  */
  function expandItem(item) {
    if (!item.classList.contains('expanded')) item.classList.add('expanded');
    var toggle = item.querySelector('.expand-block');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }

  function expandAll(root) {
    var scope = root.querySelectorAll ? root : document;
    scope.querySelectorAll('.byte-single-list-item').forEach(expandItem);
  }

  function init() {
    rewire(document);
    expandAll(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {
          var target = mutation.target;
          if (target.classList && target.classList.contains('byte-single-list-item')) {
            expandItem(target);
          }
          return;
        }
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(DIRECTIONS_SELECTOR)) rewire(node.parentNode || document);
          rewire(node);
          if (node.matches && node.matches('.byte-single-list-item')) expandItem(node);
          expandAll(node);
        });
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
